import BaseApi from "./BaseApi";

const baseUrl = 'api/SettingsAdmin/';

class SettingsAdminService {
    static async getHotleadCurrent(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}getHotleadCurrent`);
    }
    static postSettingsAdmin(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}setSettingsAdmin`, request);
    }
    static postSetErrorFrontEnd(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}setErrorFrontEnd`, request);
    }
}

export default SettingsAdminService;